import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonThumbnail, IonSkeletonText } from '@ionic/vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAccordionSkeletonItem',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonThumbnail), { slot: "start" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSkeletonText), { animated: true })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_label, null, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createVNode(_unref(IonSkeletonText), {
              animated: true,
              style: {"width":"80%"},
              class: "h3"
            })
          ]),
          _createElementVNode("p", null, [
            _createVNode(_unref(IonSkeletonText), {
              animated: true,
              style: {"width":"60%"}
            })
          ]),
          _createElementVNode("p", null, [
            _createVNode(_unref(IonSkeletonText), {
              animated: true,
              style: {"width":"30%"}
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})